export type SocialLink = {
  platform: string;
  url: string;
  label: string;
};

export const PREDEFINED_SOCIAL_PLATFORMS: Array<{
  key: string;
  label: string;
  placeholder: string;
}> = [
  { key: 'youtube',   label: 'YouTube',     placeholder: 'https://youtube.com/channel/...' },
  { key: 'facebook',  label: 'Facebook',    placeholder: 'https://facebook.com/...' },
  { key: 'instagram', label: 'Instagram',   placeholder: 'https://instagram.com/...' },
  { key: 'tiktok',    label: 'TikTok',      placeholder: 'https://tiktok.com/@...' },
  { key: 'x',         label: 'X (Twitter)', placeholder: 'https://x.com/...' },
  { key: 'linkedin',  label: 'LinkedIn',    placeholder: 'https://linkedin.com/company/...' },
  { key: 'snapchat',  label: 'Snapchat',    placeholder: 'https://snapchat.com/add/...' },
];

// Type-specific extra field types
export type SchoolDayHours = { enabled: boolean; start: string; end: string };
export type SchoolHours = { [day: string]: SchoolDayHours };

export const DAYS_OF_WEEK = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export const DEFAULT_SCHOOL_HOURS: SchoolHours = Object.fromEntries(
  DAYS_OF_WEEK.map(day => [day, { enabled: false, start: '08:00', end: '16:00' }])
);

export const FORMAT_OPTIONS = ['Website', 'Newsletter', 'Magazine', 'Newspaper', 'Podcast', 'TV', 'Radio', 'Social Media'];
export const PROGRAMS_OFFERED_OPTIONS = ['Philosophy', 'Native', 'Community Studies', 'Fiqh', 'Tajweed', 'Seerah', 'Other'];
export const AGE_RANGE_OPTIONS = ['Under 5', '5–10', '11–14', '15–18', 'Adults', 'All Ages'];

export interface OrganizationFormData {
  oid: string;
  name: string;
  slug: string;
  organizationTypeId: string;
  parentOrganizationId: string;
  provinceId: string;
  cityId: string;
  address: string;
  postalCode: string;
  phone: string;
  contact: string;
  email: string;
  website: string;
  description: string;
  languages: string[];
  mediaScope: string;
  subType: string;
  format: string;
  language: string;
  notes: string;
  isActive: boolean;
  socialLinks: SocialLink[];
  serviceDefinitionIds: string[];
  hiddenSections: string[];
  sidebarOverrideEnabled: boolean;
  // Type-specific extra fields (stored in settings.typeFields)
  craRegistration: string;
  emergencyPhone: string;
  typeFormat: string[];
  licensesAccreditation: string;
  packageTypes: string;
  programsOffered: string[];
  ageRange: string[];
  durationSchedule: string;
  programType: string;
  schoolHours: SchoolHours;
  CommunityFinanceModel: string;
  shariahCertification: string;
}



